import { observer } from 'mobx-react-lite'
import React, { useContext, useEffect } from 'react'
import { Dot } from 'react-bootstrap-icons'
import { CampaignContext } from '../../../../../contexts/CampaignContext'
import FileItem from './FileListParts/FileItem'
import DocumentUploader from '../../../../FormComponents/DocumentUploader'
import { toastError, toastSuccess } from '../../../../FormComponents/Toasts'
import axiosService from '../../../../../utils/AxiosService'
import { Droppable } from 'react-beautiful-dnd'
import { useReadOnly } from '../../../../../contexts/ReadOnlyContext'

export default observer(function FileList() {
  const { campaign, documents, campaignFolders, documentSearch: { campaign_folder_id }, documentSearch } = useContext(CampaignContext)
  const readOnly = useReadOnly()

  const deleteDocument = (document, index) => () => {
    axiosService.delete(`/api/project_manager/campaigns/${campaign.id}/documents/${document.id}`)
    .then(() => {
      documents.splice(index, 1)
      if(document.campaign_folder_id) campaignFolders.find(campaignFolder => campaignFolder.id === document.campaign_folder_id).documents_count -= 1
      toastSuccess('Document deleted')
    })
    .catch(({ data: { error }}) => toastError(error))
  }

  const onScroll = () => {
    const scrolledTo = window.scrollY + window.innerHeight;
    const isReachBottom = document.body.scrollHeight < scrolledTo + 5;
    if (isReachBottom) documentSearch.page += 1;
  };

  useEffect(() => {
    window.addEventListener("scroll", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
    };
  }, []);

  return (
    <div className="mt-12">
      <div className="flex items-center mb-2">
        <h2 className="font-bold text-base dark:text-white">Files</h2>
        <p className="font-bold text-base text-gray-300 dark:text-gray-500 flex items-center"><Dot />{documents.length}</p>
      </div>
      <Droppable droppableId="files" isDropDisabled>
        {(provided, snapshot) => (
          <div
            ref={provided.innerRef}
            {...provided.droppableProps}
            style={{ minHeight: '300px' }}
            className="flex gap-4 flex-wrap w-full y-overflow-scroll"
          >
            {!readOnly && <div className="h-80 w-64">
              <DocumentUploader
                campaign_folder_id={campaign_folder_id}
                url={`/api/project_manager/campaigns/${campaign.id}/documents`}
                onDocumentUpload={document => {
                  documents.push(document)
                  if(campaign_folder_id) campaignFolders.find(campaignFolder => +campaignFolder.id === +campaign_folder_id).documents_count += 1
                  toastSuccess("Document uploaded")
                  return
                }}
                onDocumentUploadFailure={({ data: { error }}) => toastError(error)}
              />
            </div>}
            {documents.map((document, index) => <FileItem key={document.id} document={document} deleteDocument={deleteDocument(document, index)} index={index} />)}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </div>
  )
})